// ABOUTME: The dashboard coaching ad's booking: the Nylas slot picker for a one-on-one
// ABOUTME: participant whose coach books through Nylas, otherwise the FreeBusy booking
import { just } from 'maybeasy';
import { observer } from 'mobx-react';
import * as React from 'react';
import { findLink } from '../../../LinkyLinky';
import CoachingScheduler from '../../CoachingScheduler';
import AdDisplayView from './AdDisplayView';
import FreebusyCoachingAdReady from './FreebusyCoachingAdReady';

type Props = React.ComponentProps<typeof FreebusyCoachingAdReady>;

// FreeBusy is not loaded at all when the participant books through the slot picker.
const FreebusyCoachingAdEntry: React.FC<Props> = (props) =>
  findLink('coaching-scheduler', props.freebusyCoachingAdResource.links)
    .map((schedulerLink) => (
      <CoachingScheduler
        key={schedulerLink.href}
        purpose="book"
        schedulerLink={schedulerLink}
        participantEmail={just(props.freebusyCoachingAdResource.payload.proposerParticipant.email)}
        onBooked={props.freebusyCoachingAdStore.reload}
      >
        {(open) => (
          <AdDisplayView buttonId="coaching-scheduler-ad-button" disabled={false} onClick={open} />
        )}
      </CoachingScheduler>
    ))
    .getOrElse(() => <FreebusyCoachingAdReady {...props} />);

export default observer(FreebusyCoachingAdEntry);
